import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import * as api from "../../api/index";
import { IoMdArrowBack } from "react-icons/io";

export default function ViewReviews() {
  const { id } = useParams(); // shopId (sellerId)
  const navigate = useNavigate();

  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 20;

  const fetchReviews = async (currentPage) => {
    try {
      setLoading(true);
      setError("");

      const res = await api.getShopReviews(id, currentPage, limit);
      if (res?.data) {
        setReviews(res.data.reviews || []);
        setTotalPages(res.data.totalPages || 1);
      } else {
        setReviews([]);
        setTotalPages(1);
      }
    } catch (err) {

      setError("Failed to fetch reviews");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews(page);
  }, [id, page]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50 p-6">
      {/* Back Header */}
      <div className="w-full mb-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-700 hover:text-gray-900"
        >
          <IoMdArrowBack size={24} />
          <span className="ml-1">Back</span>
        </button>
      </div>

      {/* Header */}
      <h1 className="text-2xl font-bold mb-6">Reviews</h1>

      {/* Loading / Error / Empty / Reviews */}
      {loading ? (
        <p className="text-center text-gray-500">Loading reviews...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : reviews.length === 0 ? (
        <p className="text-gray-500">No reviews yet.</p>
      ) : (
        <div className="space-y-4">
          {reviews.map((review) => (
            <div
              key={review._id}
              className="p-4 bg-white rounded-xl shadow flex flex-col"
            >
              <div className="flex items-center justify-between mb-2">
                <h2 className="font-semibold">{review.name}</h2>
               
              </div>
              <p className="text-gray-700">{review.comment}</p>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-center items-center gap-4 mt-8">
        <button
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
          disabled={page === totalPages}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}
